import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Card, CardContent, Grid } from '@mui/material';
import { useAppContext } from './AppContext';

const CreditTopUp = () => {
  const [currentCredit, setCurrentCredit] = useState(100); // Example starting credit
  const [creditToPurchase, setCreditToPurchase] = useState(0);
  const { t } = useAppContext();

  const handlePurchaseChange = (event) => {
    setCreditToPurchase(Number(event.target.value));
  };

  const handleAddCredit = () => {
    // Logic to handle adding credit
    setCurrentCredit(currentCredit + creditToPurchase);
    setCreditToPurchase(0); // Reset the purchase field after adding
  };

  return (
    <Container maxWidth="sm">
      <Card sx={{marginTop:'30px'}}>
        <CardContent>
          <Typography variant="h5" component="div" gutterBottom>
            {t("Credit Top-Up")}
          </Typography>

          <Typography variant="body1" color="textSecondary" gutterBottom>
            {t("Current Credit")}: {currentCredit}
          </Typography>

          <TextField
            label={t("Credit Amount to Purchase")}
            variant="outlined"
            type="number"
            fullWidth
            value={creditToPurchase}
            onChange={handlePurchaseChange}
            margin="normal"
          />

          <Typography variant="body1" gutterBottom>
           {t("Amount to Pay")}: {creditToPurchase*500} {t("MMK")}
          </Typography>

          <Grid container justifyContent="center" marginY={2}>
            <img src="https://www.kbzbank.com/wp-content/uploads/2019/08/Image-8_-KBZPay-Logo_Credit-to-KBZ.jpg" alt={t("Payment Gateway")} style={{ maxWidth: '150px' }} />
          </Grid>

          <Button variant="contained" color="primary" fullWidth onClick={handleAddCredit}>
            {t("Add Credit")}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default CreditTopUp;
